import { Tag } from '#app/components/Tags/Tag.js';
import { getContraImageUrl } from '#app/utilities/getContraImageUrl.js';
import { JobOutlineIcon } from '@contra/icons/icons';
import { css, styled } from 'styled-components';

const StyledJobIcon = styled(JobOutlineIcon)`
  ${({ theme }) => css`
    color: ${theme.colorsV2.gray50};
  `}
`;

export type OrganizationsListProps = {
  readonly organizations: Array<{
    icon?: string;
    logoImage?: null | { uid: string };
    name: string;
  }>;
};

export const OrganizationsList = ({
  organizations,
}: OrganizationsListProps) => {
  if (organizations.length === 0) return null;

  return (
    <>
      {organizations.map(({ icon, logoImage, name }) => {
        let logoSource;

        if (logoImage?.uid) {
          logoSource = getContraImageUrl({ uid: logoImage.uid });
        } else if (icon) {
          logoSource = icon;
        }

        return (
          <Tag
            icon={
              logoSource ? (
                <img
                  alt={`${name}-icon`}
                  src={logoSource}
                />
              ) : (
                <StyledJobIcon />
              )
            }
            key={`organization-${name}`}
            label={name}
          />
        );
      })}
    </>
  );
};
